import clsx from "clsx";

const Paper = ({ children, overflowNotApplicable }) => (
  <div className={clsx("bg-milk rounded-lg w-full h-full max-h-full", overflowNotApplicable ? "overflow-hidden" : "overflow-y-auto")}>
    {children}
  </div>
);

export default Paper;
